module.exports = __webpack_public_path__ + "img/talkinglearningmachine-hero.54e3174c.png";